export const MAX_SCREEN_WIDTH = 1200;

export const DIALOGS_INFO = {
  START_NEW_CHAT: {
    title: ({ t }) => t("ai:start_new_chat_with_question_mark"),
    message: ({ t }) => t("ai:start_new_chat_warning_msg"),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("ai:start_new"),
  },
  END_SESSION: {
    title: ({ t }) => t("ai:end_session_with_question_mark"),
    message: ({ t }) => t("ai:end_session_warning_msg"),
    buttonOneText: ({ t }) => t("ai:back_to_current_session"),
    buttonTwoText: ({ t }) => t("ai:end_session"),
  },
  RESET_CHAT: {
    title: ({ t }) => t("ai:reset_chat"),
    message: ({ t }) => t("ai:ai_tutor_reset_chat_msg"),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:reset"),
  },
};
